/* Clearazur shop + product behaviour. Vanilla JS. Each [data-clz] root initialises once; loaded deferred by clz-base.
   Add to cart: the button shows a check for a moment (clz-motion.css animates it) before the cart opens. */
(function () {
'use strict';
if (window.__clzLoaded) return;
window.__clzLoaded = true;
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
var $ = function (s, r) { return (r || document).querySelector(s); };
var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
var FR = /^fr/i.test(document.documentElement.lang || '');
var ADDING = FR ? 'Ajout…' : 'Adding…';
var ADDED = FR ? 'Ajouté' : 'Added';
var TICK = '<svg class="clz-tick" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12l5 5 9-10"/></svg> ';

function addToCart(items, after, btn) {
var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
return fetch(url, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ items: items })
}).then(function (r) {
if (!r.ok) return r.json().then(function (j) { throw new Error(j && (j.description || j.message) || 'Could not add to cart'); });
return r.json();
}).then(function () {
var cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
var dest = after === 'checkout' ? '/checkout' : cartUrl;
if (btn && !reduce) {
btn.innerHTML = TICK + (btn.getAttribute('data-added') || ADDED);
btn.classList.add('is-added');
return new Promise(function (res) { setTimeout(res, 420); }).then(function () { window.location.href = dest; });
}
window.location.href = dest;
});
}
function applyCode(code) {
if (!code) return Promise.resolve();
return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
}
function busy(btn, on, label) {
if (!btn) return;
if (on) { btn.__html = btn.innerHTML; btn.textContent = label || '…'; btn.disabled = true; }
else { if (btn.__html != null) btn.innerHTML = btn.__html; btn.disabled = false; btn.classList.remove('is-added'); }
}

var inits = {
add: function (root, cleanup) {
function onClick(e) {
var b = e.target.closest('[data-clz-add]');
if (!b || !root.contains(b)) return;
e.preventDefault();
busy(b, true, b.getAttribute('data-adding') || ADDING);
addToCart([{ id: Number(b.getAttribute('data-variant')), quantity: 1 }], root.getAttribute('data-after'), b)
.catch(function (err) { busy(b, false); b.title = err.message; });
}
root.addEventListener('click', onClick);
cleanup.push(function () { root.removeEventListener('click', onClick); });
},

shop: function (root, cleanup) {
var grid = $('[data-clz-grid]', root);
var cards = $$('[data-clz-card]', grid);
var count = $('[data-clz-count]', root);
var empty = $('[data-clz-empty]', root);
var sel = $('[data-clz-sort]', root);
var chips = $$('[data-clz-chip]', root);
var state = { f: 'all', s: 'featured' };
var one = count && count.getAttribute('data-one') || 'product';
var many = count && count.getAttribute('data-many') || 'products';
function run() {
var list = cards.filter(function (c) {
var show = state.f === 'all' || (c.getAttribute('data-tags') || '').split('|').indexOf(state.f) !== -1;
c.hidden = !show;
return show;
});
var key = { featured: 'index', new: 'new', low: 'price', high: 'price' }[state.s];
var dir = state.s === 'high' ? -1 : 1;
if (state.s === 'new') dir = -1;
list.sort(function (a, b) { return (Number(a.getAttribute('data-' + key)) - Number(b.getAttribute('data-' + key))) * dir; })
.forEach(function (c) { grid.appendChild(c); });
if (count) count.textContent = list.length + ' ' + (list.length === 1 ? one : many);
if (empty) empty.hidden = list.length > 0;
}
function onChip(e) {
var c = e.target.closest('[data-clz-chip]');
if (!c) return;
state.f = c.getAttribute('data-clz-chip');
chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
run();
}
function onSort() { state.s = sel.value; run(); }
root.addEventListener('click', onChip);
if (sel) sel.addEventListener('change', onSort);
cleanup.push(function () { root.removeEventListener('click', onChip); if (sel) sel.removeEventListener('change', onSort); });
run();
},

bundle: function (root, cleanup) {
var btn = $('[data-clz-bundle-add]', root);
if (!btn) return;
function go() {
var ids = (btn.getAttribute('data-variants') || '').split(',').filter(Boolean);
if (!ids.length) return;
busy(btn, true, ADDING);
applyCode(btn.getAttribute('data-code')).then(function () {
return addToCart(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), root.getAttribute('data-after'), btn);
}).catch(function (err) { busy(btn, false); btn.title = err.message; });
}
btn.addEventListener('click', go);
cleanup.push(function () { btn.removeEventListener('click', go); });
},

product: function (root, cleanup) {
var slides = $$('[data-clz-slide]', root);
var thumbs = $$('[data-clz-thumb]', root);
var main = $('[data-clz-main]', root);
var cur = 0, userTouched = false, timer = null, hover = false;

function show(i, byUser) {
if (!slides.length) return;
cur = (i + slides.length) % slides.length;
slides.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); s.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); });
thumbs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); });
if (byUser) { userTouched = true; stop(); }
else if (slides[cur].hasAttribute('data-clz-compare')) sweep(slides[cur]);
schedule();
}
function stop() { if (timer) { clearTimeout(timer); timer = null; } }
function schedule() {
stop();
if (reduce || userTouched || hover || slides.length < 2 || root.getAttribute('data-autoplay') === 'false') return;
var cmp = slides[cur].hasAttribute('data-clz-compare');
timer = setTimeout(function () { show(cur + 1, false); }, cmp ? 3400 : 2000);
}
function sweep(s) {
if (reduce || s.__swept) return;
s.__swept = true;
var start = performance.now(), dur = 1600;
(function step(now) {
if (s.__dragged) return;
var t = Math.min(1, (now - start) / dur);
setPos(s, 50 + Math.sin(t * Math.PI * 2) * 22 * (1 - t * .4));
if (t < 1) requestAnimationFrame(step); else setPos(s, 50);
})(start);
}
function setPos(s, v) {
s.style.setProperty('--pos', v + '%');
var r = $('input[type=range]', s); if (r) r.value = v;
}

thumbs.forEach(function (t, k) {
t.addEventListener('click', function () { show(k, true); });
t.addEventListener('mouseenter', function () { if (canHover) show(k, true); });
});
var prev = $('[data-clz-prev]', root), next = $('[data-clz-next]', root);
if (prev) prev.addEventListener('click', function () { show(cur - 1, true); });
if (next) next.addEventListener('click', function () { show(cur + 1, true); });
slides.forEach(function (s) {
var r = $('input[type=range]', s);
if (r) {
r.addEventListener('input', function () { s.__dragged = true; userTouched = true; stop(); s.style.setProperty('--pos', r.value + '%'); });
}
});
if (main) {
var x0 = null;
main.addEventListener('pointerdown', function (e) { if (e.target.tagName === 'INPUT') { x0 = null; return; } x0 = e.clientX; });
main.addEventListener('pointerup', function (e) {
if (x0 === null) return;
var d = e.clientX - x0; x0 = null;
if (Math.abs(d) > 40) show(cur + (d < 0 ? 1 : -1), true);
});
main.addEventListener('mouseenter', function () { hover = true; stop(); });
main.addEventListener('mouseleave', function () { hover = false; schedule(); });
}
show(0, false);
cleanup.push(stop);

var cta = $('[data-clz-cta]', root);
var up = $('[data-clz-upsell]', root);
var gift = $('[data-clz-gift]', root);
var sticky = $('[data-clz-sticky]', root);
var stickyBtn = sticky && $('[data-clz-sticky-add]', sticky);
function refresh() {
var on = !!(up && up.checked);
if (gift) gift.hidden = !on;
var txt = root.getAttribute(on ? 'data-text-up' : 'data-text-base');
if (!txt) return;
$$('[data-clz-total]', root).forEach(function (t) { t.textContent = txt; });
}
if (up) up.addEventListener('change', refresh);
refresh();

function buy(btn) {
var items = [{ id: Number(root.getAttribute('data-variant')), quantity: 1 }];
var withUp = up && up.checked;
if (withUp) {
items.push({ id: Number(up.getAttribute('data-variant')), quantity: 1 });
if (gift && gift.getAttribute('data-ready') === 'true') items.push({ id: Number(gift.getAttribute('data-variant')), quantity: 1 });
}
busy(btn, true, ADDING);
(withUp ? applyCode(up.getAttribute('data-code')) : Promise.resolve())
.then(function () { return addToCart(items, root.getAttribute('data-after'), btn); })
.catch(function (err) { busy(btn, false); btn.title = err.message; });
}
if (cta) cta.addEventListener('click', function () { buy(cta); });
if (stickyBtn) stickyBtn.addEventListener('click', function () { buy(stickyBtn); });

/* floating bar: shows whenever the main button is off screen, steps aside when the footer is in view */
if (sticky && cta && 'IntersectionObserver' in window) {
var io = new IntersectionObserver(function (es) {
var gone = !es[0].isIntersecting;
sticky.classList.toggle('is-on', gone);
});
io.observe(cta);
cleanup.push(function () { io.disconnect(); });
var foot = $('.shopify-section-group-footer-group') || $('footer');
if (foot) {
var fo = new IntersectionObserver(function (es) { sticky.classList.toggle('is-footer', es[0].isIntersecting); });
fo.observe(foot);
cleanup.push(function () { fo.disconnect(); });
}
}
},

reviews: function (root, cleanup) {
$$('[data-clz-odo]', root).forEach(function (el) {
var text = el.getAttribute('data-clz-odo'), k = 0;
el.textContent = '';
text.split('').forEach(function (ch) {
var cell = document.createElement('span');
cell.className = 'clz-odo__d';
if (ch >= '0' && ch <= '9') {
var strip = document.createElement('span');
strip.className = 'clz-odo__s';
strip.textContent = '0\n1\n2\n3\n4\n5\n6\n7\n8\n9';
strip.dataset.d = ch;
strip.style.transitionDelay = (k++ * 55) + 'ms';
cell.appendChild(strip);
if (ch === '1') cell.style.width = '.56em';
} else { cell.textContent = ch; }
el.appendChild(cell);
});
});
function go() { $$('.clz-odo__s', root).forEach(function (s) { s.style.transform = 'translateY(calc(' + s.dataset.d + ' * -1.15em))'; }); }
var stats = $('[data-clz-stats]', root);
if (stats && 'IntersectionObserver' in window && !reduce) {
var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); go(); } }, { threshold: .4 });
io.observe(stats);
cleanup.push(function () { io.disconnect(); });
} else go();

var dlg = $('dialog[data-clz-dlg]', root);
function open(e) { if (e) e.preventDefault(); if (dlg && dlg.showModal) { dlg.showModal(); document.documentElement.style.overflow = 'hidden'; } }
function close() { if (dlg) dlg.close(); }
function onClose() { document.documentElement.style.overflow = ''; }
$$('[data-clz-open-reviews]').forEach(function (b) { b.addEventListener('click', open); });
$$('[data-clz-close-reviews]', root).forEach(function (b) { b.addEventListener('click', close); });
if (dlg) {
dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
dlg.addEventListener('close', onClose);
}
cleanup.push(function () { $$('[data-clz-open-reviews]').forEach(function (b) { b.removeEventListener('click', open); }); onClose(); });
},

nodes: function (root, cleanup) {
var btns = $$('[data-clz-node]', root);
var panels = $$('[data-clz-np]', root);
function pick(i) {
btns.forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
panels.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
var ring = $('.rp', btns[i]);
if (ring && !reduce) {
ring.style.animation = 'none'; void ring.getBoundingClientRect(); ring.style.animation = '';
ring.onanimationend = function () { pick((i + 1) % btns.length); };
}
}
btns.forEach(function (b, k) { b.addEventListener('click', function () { pick(k); }); });
if (btns.length) pick(0);
},

faq: function (root, cleanup) {
var items = $$('[data-clz-faq]', root);
function pick(i) {
items.forEach(function (it, k) {
var on = k === i;
it.classList.toggle('is-open', on);
$('button', it).setAttribute('aria-expanded', on ? 'true' : 'false');
var bar = $('[data-clz-bar]', it);
if (bar) { bar.onanimationend = on ? function () { pick((i + 1) % items.length); } : null; }
});
}
items.forEach(function (it, k) {
$('button', it).addEventListener('click', function () { pick(it.classList.contains('is-open') ? -1 : k); });
});
if (items.length) pick(0);
}
};

function init(scope) {
$$('[data-clz]', scope || document).forEach(function (root) {
if (root.__clzReady) return;
root.__clzReady = true;
root.__clzCleanup = [];
root.getAttribute('data-clz').split(' ').forEach(function (name) {
if (inits[name]) inits[name](root, root.__clzCleanup);
});
});
}
function destroy(scope) {
$$('[data-clz]', scope || document).forEach(function (root) {
(root.__clzCleanup || []).forEach(function (f) { f(); });
root.__clzReady = false; root.__clzCleanup = [];
});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
else init();
document.addEventListener('shopify:section:load', function (e) { init(e.target); });
document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
})();